import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserService } from '../_services/user.service';

@Component({
  templateUrl: './user-actions-modal.component.html',
  styleUrls: ['./user-actions-modal.component.css']
})

export class UserActionsModalComponent {

  public user;
  userId = -1;

  public emailStates = ['Resend Introduction Email', 'Sending...', 'Sent'];
  public emailState = 0;

  constructor(
    private bsModalRef: BsModalRef,
    private userService: UserService) { }

  resendIntroductionEmail() {
    this.emailState = 1;
    this.userService.resendIntroductionEmail(this.user.userId).subscribe(() => {
      this.emailState = 2;
    });
  }

  close() {
    this.bsModalRef.hide();
  }


}

